export interface CustomerContactDocument {
  documentId: string;
  documentKey: string;
  documentDescription: string;
  selected: boolean;
}
